import { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Row } from "react-bootstrap";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import Timeline from "./Timeline";

const TimelinesContainer = ({data}) => {

    const [anlagen] = useState(data.anlagen);
    const [selectedAnlage, setSelectedAnlage] = useState(data.anlagen[0]);
    const [elvs, setElvs] = useState(data.elvs.filter(e => e.x_anlage_id[0] === data.anlagen[0].id));
    const [items, setItems] = useState([]);
    const [hasPrevious, setHasPrevious] = useState(false);
    const [hasNext, setHasNext] = useState(data.anlagen.length > 1);

    useEffect(() => {
        const currentIndex = anlagen.findIndex(a => a.id === selectedAnlage.id);
        if (anlagen.length > currentIndex + 1) {
            setHasNext(true);
        }
        if (currentIndex > 0) {
            setHasPrevious(true);
        } else {
            setHasPrevious(false);
        }
        if (currentIndex + 1 >= anlagen.length) {
            setHasNext(false);
        }
        if (currentIndex === 0) {
            setHasPrevious(false);
        }
        if (currentIndex + 1 < anlagen.length) {
            setHasNext(true);
        }
        setElvs(data.elvs.filter(e => e.x_anlage_id[0] === selectedAnlage.id));
        filterItems();
    }, [selectedAnlage]);


    const filterItems = () => {
        var temp = [];
        if (data.poolrechnungen) {
            temp = temp.concat(data.poolrechnungen.filter(p => p.x_anlage_id[0] === selectedAnlage.id));
        }
        if (data.abrechnungen) {
            temp = temp.concat(data.abrechnungen.filter(a => a.x_anlage_id[0] === selectedAnlage.id));
        }
        if (data.vorschreibungen) {
            temp = temp.concat(data.vorschreibungen.filter(v => v.x_anlage_id[0] === selectedAnlage.id));
        }
        temp.sort((a, b) => new Date(a.x_rechnungsdatum ? a.x_rechnungsdatum : a.x_eingangsdatum ? a.x_eingangsdatum : a.create_date) - new Date(b.x_rechnungsdatum ? b.x_rechnungsdatum : b.x_eingangsdatum ? b.x_eingangsdatum : b.create_date)).reverse();
        setItems(temp);
    }

    const handlePrevious = () => {
        if (hasPrevious) {
            const currentIndex = anlagen.findIndex(a => a.id === selectedAnlage.id);
            if (currentIndex > 0) {
                setSelectedAnlage(anlagen[currentIndex - 1]);
            }
        }
    }

    const handleNext = () => {
        if (hasNext) {
            const currentIndex = anlagen.findIndex(a => a.id === selectedAnlage.id);
            if (currentIndex < anlagen.length - 1) {
                setSelectedAnlage(anlagen[currentIndex + 1]);
            }
        }
    }

    return (
        <>
            <Row className="align-items-center">
                <Col xs="4" className="text-end">
                    <Button variant="energo" disabled={!hasPrevious} onClick={() => handlePrevious()}>
                        <FaChevronLeft size={30} />
                    </Button>
                </Col>
                <Col xs="4" className="text-center">
                    <p>Ihre Anlagen</p>
                    <Card style={{background: "#a2c13f", color:"white", borderRadius: 20, border: "20px solid #a2c13f"}}>
                        <CardBody>
                            <p>{selectedAnlage.id}</p>
                            <p>Anlage {selectedAnlage.x_studio_field_3eKe0}</p>
                            <p>Anlagenadresse {selectedAnlage.x_adresse_kompakt}</p>
                        </CardBody>
                    </Card>
                </Col>
                <Col xs="4">
                    <Button variant="energo" disabled={!hasNext} onClick={() => handleNext()}>
                        <FaChevronRight size={30} />
                    </Button>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    {elvs && elvs.length > 0 && elvs.map(e => (
                        <Timeline 
                            key={e.id} 
                            elv={e} 
                            items={items.filter(i => i.x_energieliefervertrag_id && i.x_energieliefervertrag_id[0] == e.id)} 
                        />
                    ))}
                </Col>
            </Row>
        </>
    )
}
export default TimelinesContainer;